import {observer} from "mobx-react-lite";
import { QuizView } from "../views/quizView.jsx";
import { NavBar } from "./navBarPresenter.jsx";
import React from "react";
import confetti from 'canvas-confetti';

const Quiz = observer(

    function QuizRender(props){ 

        function onNextClick() {
            updateScore();
    
            if (props.model.currentQuestion < props.model.questionData.length-1) {
                props.model.setCurrentQuestion(props.model.currentQuestion+1)
                props.model.setClickedOption(0);
                if(props.model.currentQuestion === 1){
                    props.model.setCurrentQuizID(generateUniqueId());
                }
            } else {
                props.model.setShowQuizSummary(true);
                if (props.model.score > 7) {fireConfetti()};
                props.model.updateQuizHistory();
            }
        }

        function updateScore() {
            if (props.model.clickedOption === (props.model.questionData[props.model.currentQuestion].answer+1)) {
                props.model.setScore(props.model.score + 1)
            }
        }
    
        function restartClick() {
            props.model.setShowQuizSummary(false)
            props.model.setCurrentQuestion(0)
            props.model.setClickedOption(0);
            props.model.setScore(0)
        }


        function onAnwerClick(id) {
            props.model.setClickedOption(id);
        }

        function fireConfetti() {
            var duration = 4 * 1000;
            var animationEnd = Date.now() + duration;
            var defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };
            
            function randomInRange(min, max) {
              return Math.random() * (max - min) + min;
            }
            
            var interval = setInterval(function() {
              var timeLeft = animationEnd - Date.now();
            
              if (timeLeft <= 0) {
                return clearInterval(interval);
              }
            
              var particleCount = 50 * (timeLeft / duration);
              // since particles fall down, start a bit higher than random
              confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } });
              confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } });
            }, 250);
        }

        function generateUniqueId() {
            return Math.random().toString(36).substr(2, 9);
        }

        return (
            <div>
                <NavBar model={props.model}/>
                <QuizView 
                    questionData={props.model.questionData} 
                    nextQuestion={onNextClick}
                    selectAnswer={onAnwerClick}
                    restartQuiz={restartClick}
                    currentQuestion={props.model.currentQuestion}
                    clickedOption={props.model.clickedOption}
                    score={props.model.score}
                    showQuizSummary={props.model.showQuizSummary}
                />
            </div>
        )

    }

);

export {Quiz}